import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';
import { toast, ToastContainer } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import useConfiguration from '../../utils/ConfigurationContext';
import { useUser } from '../../utils/userContext';
import logo from '../../assets/globalImgs/WW-360-Logo.png';
import Select from 'react-select';
import { data } from 'jquery';


const LeaveBalance = () => {

    const [leaveDetails, setLeaveDetails] = useState([]);
    const [leaveUpdateDetails, setLeaveUpdateDetails] = useState([]);
    const [tableHeader, setTableHeader] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const { user } = useUser();
    const handleErrors = useHandleErrors();
    const config = useConfiguration();
    const [empId, setEmpId] = useState(null);
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);
    const [employess, setEmployess] = useState([]);
    const [isUpdating, setIsUpdating] = useState([]);
    const [monthlyLeaves, setMonthlyLeaves] = useState(null);
    const ClearIndicator = () => null;


    const handleAssignModal = async (id) => {
        setEmpId(id);
        setIsUpdating(true);
        setShowAssignModal(true);
        if (id) {
            await fetchEmpLeaveBalances(id);
        }
    };

    const handleCloseLeaveModal = () => setShowAssignModal(false);


    const handleChange = (e, type, field) => {
        setLeaveUpdateDetails({
            ...leaveUpdateDetails,
            [type]: {
                ...leaveUpdateDetails[type],
                [field]: e.target.value,
            },
        });
    };


    const fetchLeaveBalances = async () => {
        setLoading(true)
        try {
            const path = "/getLeaveBalance";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            if (response.status === 200) {
                setLeaveDetails(response.data.userLeaveBalance);
                const data = response.data.userLeaveBalance;

                if (data.length > 0 && data[0].leaveBalance) {
                    const headers = data[0].leaveBalance.map(leave => leave.leaveType.toLowerCase());
                    setTableHeader(headers);
                }

                setLeaveDetails(data);
            } else {
                handleErrors(response)
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    // Handle 404 status code separately
                    setLeaveDetails([]);
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchLeaveBalances();
            fetchEmployess();
            hasFetchedRef.current = true;
        }
    }, []);


    const fetchEmpLeaveBalances = async (employeeId) => {
        setLoading(true);
        try {
            const path = `/getLeaveBalance?employeeId=${employeeId}`;
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            if (response.status === 200) {
                const data = response.data.userLeaveBalance;
                // Populate old leave values for modal
                if (data.length > 0 && data[0].leaveBalance) {
                    const oldDetails = {};
                    data[0].leaveBalance.forEach(leave => {
                        oldDetails[leave.leaveType] = {
                            hours: leave.noOfLeaves,
                            reason: ''
                        };
                    });
                    setLeaveUpdateDetails(oldDetails);
                } else {
                    setLeaveUpdateDetails({});
                }
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setLeaveUpdateDetails({});
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };
    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Leave Balance');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            const today = new Date();
            const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
            const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
            const formattedDate = `${year}${month}${day}`;
            link.download = `WW360-Leave_Balance_Report_${formattedDate}.xlsx`;

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Leave Balance List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const shareData = {
        title: 'Leave Balance List',
        text: 'Check out the Leave Balance list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const exportToExcel = () => {
        // Prepare data for Excel export
        const dataToExport = leaveDetails.map(employee => {
            const row = { EmployeeID: employee.employeeId };
            tableHeader.forEach(header => {
                const leaveData = employee.leaveBalance.find(leave => leave.leaveType.toLowerCase() === header);
                row[header] = leaveData ? leaveData.noOfLeaves : 'N/A';
            });
            return row;
        });

        // Add headers, logo URL, and timestamp
        let worksheet = XLSX.utils.json_to_sheet(dataToExport, { skipHeader: true });

        // Insert logo and timestamp in the first row
        XLSX.utils.sheet_add_aoa(worksheet, [
            [{ v: logo, t: 's' }, '', '', '', { v: 'Timestamp: ' + new Date().toLocaleString(), t: 's' }]
        ], { origin: 'A1' });

        // Add headers
        XLSX.utils.sheet_add_aoa(worksheet, [
            ['Employee ID', ...tableHeader.map(header => header.charAt(0).toUpperCase() + header.slice(1))]
        ], { origin: 'A2' });

        // Add data
        XLSX.utils.sheet_add_json(worksheet, dataToExport, { origin: 'A3', skipHeader: true });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "LeaveBalanceReport");

        // Create Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(blob, `WW360-Leave_Balance_Report_${formattedDate}.xlsx`);
    };


    useEffect(() => {
        setFilteredData(
            leaveDetails.filter(data =>
                data.employeeId.toLowerCase().includes(searchQuery.toLowerCase()) ||
                data.employeeName.toLowerCase().includes(searchQuery.toLowerCase()) 
                
            )
        );
    }, [searchQuery, leaveDetails]);

    const handleLeavesSubmit = async () => {
        setLoading(true);
        const leaveBalance = Object.entries(leaveUpdateDetails).map(([type, details]) => ({
            LeaveType: type,
            NoOfLeaves: details.newHours ? details.newHours : "0", // Only send new hours
            Reason: details.reason ? details.reason : ""    // Default to empty string if no reason provided
        }));

        const payload = {
            EmployeeId: empId,
            LeaveBalance: leaveBalance.length > 0 ? leaveBalance : config?.leaveManagement?.holidayTypes?.map(type => ({
                LeaveType: type,
                NoOfLeaves: "0",
                Reason: "" // Default empty reason when no data provided
            })) || [],
            MonthlyLeaveBalance: monthlyLeaves?monthlyLeaves:null,
            UpdatedBy: user?.FirstName
        };

        try {
            const path = "/insertLeaveBalance";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, payload, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            if (response.status === 200) {
                toast.success("Leave Balances Added Succesfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setShowAssignModal(false);
                setLeaveUpdateDetails([])
                fetchLeaveBalances();
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const toTitleCase = (str) => {
        return str.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };


    const fetchEmployess = async () => {
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setEmployess(response.data.onboardEmployeeDetails);
            }
            else {
                handleErrors(response)
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    const employeeOptions = employess.map((emp) => ({
        value: emp.EmployeeId,
        label: `${emp.EmployeeId}`,
    }));


    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);


    const paginate = pageNumber => setCurrentPage(pageNumber);

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Leave Balance</h3>
                        </div>
                        <div className="col-auto">
                            <Button
                                variant="primary"
                                className="mt-lg-0 mt-4"
                                onClick={() => {
                                    setEmpId("");
                                    setIsUpdating(false);
                                    setShowAssignModal(true);
                                }}
                            >
                                <i className="ri-calendar-schedule-fill"></i> Assign Leaves
                            </Button>
                        </div>
                    </div>
                    {leaveDetails?.length === 0 ? (
                        <div class="container">
                            <div class="row vh-50 justify-content-center align-items-center">
                                <div class="col-auto">
                                    <div class="no-data-wrapper">
                                        <div class="no-data-found">
                                            <i class="ri-file-damage-fill"></i>
                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                            <p>No Data Found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div class="row align-items-center justify-content-center">
                                <div class="col-lg-5 col-md-8 col-sm-10">
                                    <div class="container-fluid row-rounded mb-0">
                                        <div class="row px-2 py-0">
                                            <div class="input-group mb-0">
                                                <input
                                                    type="search"
                                                    className="form-control search-input"
                                                    placeholder="Keyword search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                />                                                        <div class="input-group-append">
                                                    <button class="btn btn-primary" type="button" title="Search" rel="tooltip"><i class="ri-menu-search-line"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <small class="form-text text-muted text-center mt-0"><i class="ri-information-2-fill text-info"></i> Allows: Emp ID- Emp Name  </small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card mb-4">
                                        <div class="card-body">

                                            <div class="row">
                                                <div class="col">
                                                    <h5 class="title mt-1 mb-0">Leave Balance</h5>
                                                </div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        title="Email"
                                                        rel="tooltip"
                                                        className="btn btn-light btn-circle ml-2"
                                                        onClick={() => sendEmail('')}
                                                    >
                                                        <i className="ri-mail-send-fill"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        title="Share"
                                                        rel="tooltip"
                                                        className="btn btn-light btn-circle ml-2"
                                                        onClick={handleShare}
                                                    >
                                                        <i className="ri-share-fill"></i>
                                                    </button>
                                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={exportToExcel}>
                                                        <i className="ri-export-fill"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="table-responsive leave-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>Emp ID</th>
                                                                    <th>Emp Name</th>
                                                                    {/* {tableHeader.map((header, idx) => (
                                                                        <th key={idx}>{toTitleCase(header)}</th>
                                                                    ))} */}
                                                                    {config?.leaveManagement?.holidayTypes?.map((header, idx) => (
                                                                        <th key={idx}>{toTitleCase(header)}</th>
                                                                    ))}

                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords.map((employee, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                                        <td>{employee.employeeId}</td>
                                                                        <td>{employee.employeeName}</td>
                                                                        {/* {tableHeader.map((header, idx) => (
                                                                            <td key={idx}>
                                                                                {employee.leaveBalance.find(leave => leave.leaveType.toLowerCase() === header) ? (
                                                                                    <span className="text-info border badge border-info">
                                                                                        {employee.leaveBalance.find(leave => leave.leaveType.toLowerCase() === header).noOfLeaves}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="text-danger border badge border-danger">0</span>
                                                                                )}
                                                                            </td>
                                                                        ))} */}
                                                                        {config?.leaveManagement?.holidayTypes?.map((header, idx) => {
                                                                            const leaveBalance = employee.leaveBalance.find(leave => leave.leaveType.toLowerCase() === header.toLowerCase());

                                                                            return (
                                                                                <td key={idx}>
                                                                                    <span className={`text-${leaveBalance ? 'info' : 'danger'} border badge border-${leaveBalance ? 'info' : 'danger'}`}>
                                                                                        {leaveBalance ? leaveBalance.noOfLeaves : 0}
                                                                                    </span>
                                                                                </td>
                                                                            );
                                                                        })}

                                                                        <td className="text-center">
                                                                            <span>
                                                                                <button
                                                                                    className="btn btn-link text-info btn-action custom-dropdown-btn dropdown-toggle"
                                                                                    type="button"
                                                                                    title="Update"
                                                                                    onClick={() => handleAssignModal(employee.employeeId)}
                                                                                    rel="tooltip"
                                                                                >
                                                                                    <i className="ri-list-settings-line"></i>
                                                                                </button>
                                                                            </span>
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {showAssignModal && (
                <Modal show={showAssignModal} onHide={handleCloseLeaveModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Assign Leaves</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col">
                                <h5 className="title mt-1 mb-0">
                                    <span data-toggle="popover" data-html="true" data-content="<div><b>Employee Fullname</b><br>firstname.lastname@email.com<br>Admin</div>">
                                    </span>
                                    <small>
                                        <div className="form-group col-md-12">
                                            <label htmlFor="ManagerEmail" className="required">
                                                EmployeeId:
                                            </label>
                                            {isUpdating ? (
                                                <span>{" " + empId}</span> // Show as non-editable text
                                            ) : (
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    name="EmployeeId"
                                                    value={employeeOptions.find((option) => option.value === empId) || null}
                                                    onChange={async (selectedOption) => {
                                                        const selectedId = selectedOption ? selectedOption.value : "";
                                                        setEmpId(selectedId);
                                                        if (selectedId) {
                                                            await fetchEmpLeaveBalances(selectedId);
                                                        } else {
                                                            setLeaveUpdateDetails({});
                                                        }
                                                    }}
                                                    options={employeeOptions}
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                    isLoading={loading}
                                                />
                                            )}
                                        </div>
                                        <div className="form-group mt-2">
                                            <label className="d-block">Add Monthly Leaves</label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                name="monthlyLeaves"
                                                value={{ value: monthlyLeaves, label: monthlyLeaves }}
                                                onChange={(selectedOption) => setMonthlyLeaves(selectedOption.value)}
                                                options={[
                                                    { value: "Yes", label: "Yes" },
                                                    { value: "No", label: "No" },
                                                ]}
                                                isClearable
                                                components={{ ClearIndicator }}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />
                                        </div>
                                    </small>

                                </h5>
                            </div>
                            <div className="col-auto"></div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-12">
                                <Table responsive>
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Leave Type</th>
                                            <th className="text-center" width="90">Old</th>
                                            <th className="text-center" width="90">New</th>
                                            <th>Reason</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {config?.leaveManagement?.holidayTypes?.map(type => (
                                            <tr key={type}>
                                                <td className="paid-leave">{type}</td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="0"
                                                        value={leaveUpdateDetails[type]?.hours || ''}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="0"
                                                        value={leaveUpdateDetails[type]?.newHours || ''}
                                                        onChange={(e) => handleChange(e, type, 'newHours')}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={leaveUpdateDetails[type]?.reason || ''}
                                                        onChange={(e) => handleChange(e, type, 'reason')}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center py-2">
                        <Button variant="light" onClick={handleCloseLeaveModal}>Cancel</Button>
                        <Button variant="primary" onClick={handleLeavesSubmit} disabled={!empId}>
                            Submit <i className="ri-checkbox-circle-line"></i>
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}


        </div>
    )
}

export default LeaveBalance
